import { render, staticRenderFns } from "./TeacherProfileInfo.vue?vue&type=template&id=2875da48&scoped=true&"
import script from "./TeacherProfileInfo.vue?vue&type=script&lang=js&"
export * from "./TeacherProfileInfo.vue?vue&type=script&lang=js&"
import style0 from "./TeacherProfileInfo.vue?vue&type=style&index=0&id=2875da48&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2875da48",
  null
  
)

export default component.exports